import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DataCube from '../data-cube';
import {
  dataCategories,
  humanizeNumber,
  colorMatcher,
} from '../../helpers/formatters';
import styles from './data-cube-row.module.scss';
import { labelMatcher } from '../../helpers/label-mapper'

class DataCubeRow extends Component {
  getCubeData(label, councilData) {
    if (councilData.isBlank && label !== 'relativeRiskAssessment') return '-';

    switch (label) {
      case 'assets':
        return councilData.assets.total;
      case 'avgConsumptionCharge':
        return councilData.avgConsumptionCharge;
      case 'avgServiceCharge':
        return councilData.avgServiceCharge;
      case 'capacity':
        return councilData.capacity;
      case 'dams':
        return councilData.dams;
      case 'entityType':
        return councilData.entityType;
      case 'expenses':
        return councilData.expenses.total;
      case 'name':
        return councilData.name;
      case 'liabilities':
        return councilData.liabilities.total;
      // case 'name':
      //   return councilData.name;
      case 'revenue':
        return councilData.revenue.total;
      case 'shareholderReturns':
        return councilData.shareholderReturns.total;
      default:
        return null;
    }

    // switch (label) {
    //   case 'revenue':
    //     return councilData.revenue.total;
    //   case 'expenses':
    //     return councilData.expenses.total;
    //   case 'assets':
    //     return councilData.assets.total;
    //   case 'liabilities':
    //     return councilData.liabilities.total;
    //   case 'other':
    //     return councilData.other.increaseDecreaseInAssetRevaluationSurplus;
    //   case 'relativeRiskAssessment':
    //     return null;
    //   default:
    //     return null;
    // }
  }
  renderCubes(councilData, type) {
    const { onCubeClick, activeEntity, comparedEntity } = this.props;

    let comparableCategories = ['revenue', 'expenses', 'assets', 'liabilities', 'otherInformation']
    if(
        (comparedEntity != null) &&
        ((["CS Energy", "Stanwell"].indexOf(activeEntity.name) >= 0 &&
        ["EEQ"].indexOf(comparedEntity.name) >= 0) || 
        (["EEQ"].indexOf(activeEntity.name) >= 0 &&
        ["CS Energy", "Stanwell"].indexOf(comparedEntity.name) >= 0))
    ) {
      comparableCategories = ['revenue']
    }

    const categories = type
      ? dataCategories.filter(
        category => {
          return (category.id !== 'otherInformation' &&
                    comparableCategories.indexOf(category.id) >= 0)
        }
      )
      : dataCategories;

    
    
    return (
      <div
        style={{ marginBottom: type === 'top' ? '45px' : 0 }}
        className={styles.dataCubeRow}
      >
        {categories
          // Universities have no 'other comprehensive income'
          .filter(category => !(category.id === 'other'))
          .map((category, i) => {
            return (
              <DataCube
                key={i}
                label={category.label}
                value={humanizeNumber(
                  this.getCubeData(category.id, councilData),
                  category.unit
                )}
                type={type}
                color={colorMatcher(category.color)}
                onClick={() => onCubeClick(category.id)}
              />
            );
          })}
      </div>
    );
  }

  renderDoubleRow() {
    const { comparedEntity, activeEntity, onCubeClick } = this.props;
    const otherInformationData = dataCategories.find(
      category => category.id === 'otherInformation'
    );

    const revenueOnly = (
        (["CS Energy", "Stanwell"].indexOf(activeEntity.name) >= 0 &&
        ["EEQ"].indexOf(comparedEntity.name) >= 0) || 
        (["EEQ"].indexOf(activeEntity.name) >= 0 &&
        ["CS Energy", "Stanwell"].indexOf(comparedEntity.name) >= 0)
    ) ? true : false;

    return (
      <div>
        <div className={styles.dataCubeRowTitle}>{labelMatcher(activeEntity.name)}</div>
        <div className={styles.cubesDoubleRowWrapper}>
          <div className={styles.cubesDoubleRowComparing}>
            {this.renderCubes(activeEntity, 'top')}
            <div className={styles.dataCubeRowTitle}>
              {labelMatcher(comparedEntity.name)}
            </div>
            {this.renderCubes(comparedEntity, 'bottom')}
          </div>
          { !revenueOnly &&
            <DataCube
              label={otherInformationData.label}
              text={otherInformationData.text}
              color={colorMatcher(otherInformationData.color)}
              onClick={() => onCubeClick(otherInformationData.id)}
            />
          }
        </div>
      </div>
    );
  }

  render() {
    const { comparedEntity, activeEntity } = this.props;

    return (
      <div className={styles.dataCubeRowWrapper}>
        {comparedEntity 
          ? this.renderDoubleRow()
          : this.renderCubes(activeEntity)}
      </div>
    );
  }
}

DataCubeRow.propTypes = {
  activeEntity: PropTypes.object.isRequired,
  comparedEntity: PropTypes.object,
  onCubeClick: PropTypes.func.isRequired,
};

export default DataCubeRow;



// WEBPACK FOOTER //
// ./src/components/data-cube-row/data-cube-row.js